import React, { useEffect, useState } from "react";
import DashboardHeader from "../../../components/header/DashboardHeader";
import "./Overview.scss";
import { avatar, dummyCard, live_groups_vdo } from "../../../assets";
import { Link, useNavigate } from "react-router-dom";
import { FaRegCommentDots } from "react-icons/fa";
import { RiShareForwardLine } from "react-icons/ri";
import { HiDotsVertical } from "react-icons/hi";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { CiSearch } from "react-icons/ci";
import { GoArrowRight } from "react-icons/go";
import { fetchOverviewListApi } from "../../../services/overview";
import moment from "moment";
import { reactions } from "../../../utils/staticData";
import { feedDetailApi, feedReactionApi } from "../../../services/feeds";
import { toastMessage } from "../../../utils/toastMessage";
import OverviewComment from "./section/OverviewComment";
import { handleCopy } from "../../../utils/copyClipboard";
import InfiniteScroll from "react-infinite-scroll-component";
import OverviewReport from "./section/OverviewReport";
import OverviewListShimmer, {
  LiveShimmer,
} from "../../../shimmer/overview/OverviewListshimmer";
import useDebounce from "../../../hooks/useDebounce";
import { getCheckLiveApi } from "../../../services/groupMember";
import { encryptData } from "../../../utils/dataCipher";
import Slider from "react-slick";
import DeleteFeed from "./section/DeleteFeed";
import { overViewDetailsLink } from "../../../utils/shareLink";
import NotFoundPlaceHolder from "../../../components/not-found/NotFoundPlaceHolder";
import FlatList from "components/FlatList";
import { setFeedPage, setOverviewList } from "store/slices/feedSlice";

const Overview = () => {
  const { overviewList, page, loaded } = useSelector((state) => state.feeds);
  console.log("🌹 ~ Overview ~ overviewList:", overviewList);

  const { showAuth } = useSelector((state) => state?.showAuth);

  const dispatch = useDispatch();
  const [categoryList, setCategoryList] = useState([]);
  const [pageLoader, setPageLoader] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [hasMore, setHasMore] = useState(true);
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  const [live, setLive] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // console.log('categoryList', categoryList)
  //---------#--------------
  useEffect(() => {
    setCategoryList(showAuth?.interestedCategories);
  }, [showAuth?.interestedCategories]);
  // ---------handle-commit------------
  const handleComment = (data) => {
    setSelectedData(data);
    setCommentModal(true);
  };
  // ---------handle-commit------------
  const handleReport = (data) => {
    setSelectedData(data);
    setReportModal(true);
  };
  // ---------handle-Delete------------
  const handleDelete = (data) => {
    setSelectedData(data);
    setDeleteModal(true);
  };
  // -----------handle-reaction-API---------------------
  const handleFeedsReaction = async (reaction, feedData) => {
    try {
      setSelectedData(feedData || {});
      const { data } = await feedReactionApi({
        _feed: feedData?._id,
        reaction,
      });
      const { success, message } = data;
      if (success) {
        getFeedDetail(feedData?._id);
      } else {
        //-------error-message-show-only---------
        toastMessage(
          message,
          success ? "success" : "error",
          "handleFeedsReaction"
        );
      }
    } catch (e) {
      console.error(e.message);
    }
  };

  //----------feed-details-api---------------
  const getFeedDetail = async (_id) => {
    try {
      const { data } = await feedDetailApi({ _id });
      const { success, message, data: response } = data;
      if (success) {
        // Find the item in categoryList
        const findIndex = overviewList?.findIndex((data) => data?._id === _id);
        if (findIndex !== -1) {
          setOverviewList((prev) =>
            prev.map((item, index) => (index == findIndex ? response : item))
          );
        }
      } else {
        toastMessage(message, "error", "getFeedDetail");
      }
    } catch (e) {
      console.error("Error:-", e.message);
    }
  };

  //-------------overview-list-------------------
  const fetchOverviewList = async (
    page = 1,
    isRefresh = false,
    search = debouncedValue
  ) => {
    try {
      setLoading(true);
      const { data } = await fetchOverviewListApi({
        pagination: true,
        limit: 9,
        page,
        search,
      });
      const { success, message, data: response } = data;
      if (success) {
        if (isRefresh) {
          console.log("🌹 ~ fetchOverviewList ~ response:", response);
          dispatch(setOverviewList(response));
        } else {
          dispatch(setOverviewList([...overviewList, ...response]));
        }
        setHasMore(response.length === 9);
      } else {
        toastMessage(message, "error", "errorOverView");
      }
    } catch (e) {
      console.error("Error fetching overview list:", e.message);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  const onChangeHandler = (e) => {
    setSearch(e.target.value);
    if (e.target.value?.length <= 0) {
      setHasMore(true);
      fetchOverviewList(1, true, "");
    }
  };

  useEffect(() => {
    if (debouncedValue) {
      dispatch(setFeedPage(1));
      setHasMore(true);
      fetchOverviewList(1, true);
    }
  }, [debouncedValue]);

  useEffect(() => {
    if (!loaded) {
      setHasMore(true);
      fetchOverviewList(1, true);
    }
  }, [loaded]);

  const fetchMoreData = () => {
    dispatch(setFeedPage(page + 1));
    fetchOverviewList(page + 1);
  };

  //-----------check-here-live-or-not-----------------
  useEffect(() => {
    const getLiveCheck = async () => {
      try {
        setPageLoader(true);
        const response = await getCheckLiveApi();
        if (response?.data?.success) {
          setLive(response?.data?.data?.userLive);
        }
      } catch (e) {
        console.log("Error:-", e.message);
      } finally {
        setPageLoader(false);
      }
    };
    getLiveCheck();
  }, []);

  var settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    infinite: false,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  // //-----------check-here-live-or-not-----------------
  // const getLiveCheck = async () => {
  //   try {
  //     const response = await getCheckLiveApi()
  //     if (response?.data?.success) {
  //       setLive(response?.data?.data?.userLive)
  //     }
  //   } catch (e) {
  //     console.log("Error:-", e.message);
  //   }
  // };
  // console.log('overviewList', overviewList)

  return (
    <>
      <DashboardHeader title={"Overview"} />

      <div className="dashboard_pages">
        <div className="over_view">
          <div className="over_view_header">
            <div className="tab_button_wrap">
              <FlatList
                data={categoryList}
                renderItem={(category) => {
                  return (
                    <div
                      key={category._id}
                      className="tab_button"
                      onClick={() =>
                        navigate(
                          `/dashboard/category/group-list?info=${encryptData({
                            ...category,
                            type: "overview",
                          })}`
                        )
                      }
                    >
                      <Link to={""} className="menu-item">
                        <img src={category?.image} alt="Technology Icon" />
                        {category?.name}
                      </Link>
                    </div>
                  );
                }}
              />
            </div>
            <div className="search_wrap">
              <CiSearch className="search_icon" />

              <input
                type="text"
                className="input form-control"
                placeholder="Search here"
                value={search || ""}
                onChange={onChangeHandler}
              />
            </div>
          </div>
          {/* -----------live-group---------------------- */}
          {pageLoader ? (
            <LiveShimmer />
          ) : (
            String(live) !== "0" && (
              <div className="live_group_parent mb-3">
                <div className="live_group_left">
                  <img src={live_groups_vdo} alt="" />
                  <div className="live_grp_txt">
                    <b>All Live Groups</b>
                    <p>
                      The groups that live streaming currently will appear here.
                    </p>
                  </div>
                </div>
                <div className="live_group_right">
                  <Link to={"/dashboard/overview/live-details"}>
                    <GoArrowRight className="live_group_icon" />
                  </Link>
                </div>
              </div>
            )
          )}

          {/* Infinite Scroll Section */}
          {overviewList.length > 0 || loading ? (
            <InfiniteScroll
              dataLength={overviewList.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loader={loading && <OverviewListShimmer count={6} />}
            >
              {/* ----------------card-section--------------------- */}
              <div className="cards_container card_wrap">
                <FlatList
                  data={overviewList}
                  renderItem={(card) => {
                    return (
                      <div className="_card" key={card._id}>
                        <div className="_cards_header">
                          <div className="cardtop_header">
                            <div className="user_image">
                              <img
                                src={card?._group?.coverImage || avatar}
                                alt={card?.createdBy?.fullName}
                              />
                            </div>
                            <div className="info">
                              <h5 className="name">
                                {card?._group?.name || "N/A"}
                              </h5>
                              <p className="time">
                                {card?.createdBy?.fullName && (
                                  <>
                                    Posted by{" "}
                                    {card?._group?.settings?.anonymousPosting
                                      ? "Anonymous"
                                      : card?.createdBy?.fullName}{" "}
                                    - {moment(card?.createdAt).fromNow()}
                                  </>
                                )}
                              </p>
                            </div>
                          </div>

                          <Dropdown className="custom_dropdown">
                            <Dropdown.Toggle id="dropdown-basic">
                              <HiDotsVertical />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              {card?.createdBy?._id === showAuth?._id ? (
                                <>
                                  <Dropdown.Item
                                    as={Link}
                                    to={`/dashboard/feed/edit-feed/${card?._id}`}
                                  >
                                    Edit
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => handleDelete(card)}
                                  >
                                    Delete
                                  </Dropdown.Item>
                                </>
                              ) : (
                                <Dropdown.Item
                                  onClick={() => handleReport(card)}
                                >
                                  Report
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>

                        <div className="card_image">
                          <Link
                            to={`/dashboard/overview/detail/${card?._id}`}
                          ></Link>
                          <Slider {...settings}>
                            {card?.attachments &&
                            card.attachments.length > 0 ? (
                              card.attachments.map((data, ind) => (
                                <div
                                  key={ind}
                                  className="upload_design_content overwrite_upload_design_content"
                                >
                                  {data.type === "VIDEO" ? (
                                    <video
                                      controls
                                      width="100%"
                                      poster={data.thumbnailUrl}
                                    >
                                      <source src={data.url} type="video/mp4" />
                                      Your browser does not support the video
                                      tag.
                                    </video>
                                  ) : (
                                    <img
                                      className="mqwertyu"
                                      src={data.url}
                                      alt="attachment"
                                    />
                                  )}
                                </div>
                              ))
                            ) : (
                              <div className="upload_design_content overwrite_upload_design_content">
                                <img src={dummyCard} alt="attachment" />
                              </div>
                            )}
                          </Slider>
                          <span className="tag">
                            {card?._group?.categoryName || "N/A"}
                          </span>
                        </div>

                        <div className="card_content">
                          <h3>
                            <Link
                              to={`/dashboard/overview/detail/${card?._id}`}
                            >
                              {card?.title || "N/A"}{" "}
                            </Link>
                          </h3>

                          <div className="card_footer">
                            <button className="card_footer_btn">
                              {reactions?.map((reactionData, ind) => (
                                <span
                                  key={ind}
                                  className=" me-1 emojireaction"
                                  onClick={() =>
                                    handleFeedsReaction(
                                      reactionData?.name,
                                      card
                                    )
                                  }
                                >
                                  {card?.myReaction?.[reactionData?.name]
                                    ? reactionData?.fillEmoji
                                    : reactionData?.emoji}
                                  {card?.reactions?.[reactionData?.name] || ""}
                                </span>
                              ))}
                            </button>

                            <button
                              className="card_footer_btn"
                              onClick={() => handleComment(card)}
                            >
                              <FaRegCommentDots /> Comments
                            </button>
                            <button
                              onClick={() =>
                                handleCopy(`${overViewDetailsLink}${card?._id}`)
                              }
                              className="card_footer_btn"
                            >
                              <RiShareForwardLine /> Share
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  }}
                />
              </div>
            </InfiniteScroll>
          ) : (
            <NotFoundPlaceHolder title="No Feeds available" />
          )}
        </div>
      </div>

      {/* ---------comments--------------------- */}
      <OverviewComment
        show={commentModal}
        close={() => setCommentModal(false)}
        selectedData={selectedData}
        pageName="Post"
      />

      {/* ---------report--------------------- */}
      <OverviewReport
        show={reportModal}
        close={() => setReportModal(false)}
        selectedData={selectedData}
        pageName="Post"
        type="FEED"
      />

      {/* //-----------feed-request----------------- */}
      {deleteModal && (
        <DeleteFeed
          show={deleteModal}
          close={() => setDeleteModal(false)}
          scroll={true}
          listing={fetchOverviewList}
          id={selectedData?._id}
          feedName={selectedData?._group?.name}
          setPage={(param) => dispatch(setFeedPage(param))}
          setHasMore={setHasMore}
        />
      )}
    </>
  );
};

export default Overview;
